import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import Autocomplete from '@material-ui/lab/Autocomplete'
import React from 'react'
import { useActions, useValues } from 'kea';

import grouplogic from 'src/store/group'
import geofencelogic from 'src/store/geofence'
import { CircularProgress } from '@material-ui/core'

//TODO fix autocomplete
const AssignGroupDialog = ({ selectedGeofence }) => {
	// const [selectedGeofence, setVehicle] = useState(props.selectedGeofence);
	const [open, setOpen] = React.useState(false);
	const [newGroups, setNewGroups] = React.useState(selectedGeofence.groups.map((g) => g._id) || []);

	const { groups } = useValues(grouplogic);
	const { fetchAll: groupFetchAll } = useActions(grouplogic);

	const { updateGroup } = useActions(geofencelogic);

	React.useEffect(() => {
		groups ?? groupFetchAll();
	}, []) // eslint-disable-line

	React.useEffect(() => {
		setNewGroups(selectedGeofence.groups.map((g) => g._id) || [])
	}, [selectedGeofence])

	const handleClickOpen = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
	}

	const handleChange = (e, newValue) => {
		// console.log(newValue);
		let update_groups = [...newGroups];
		update_groups = newValue;
		setNewGroups(update_groups);
	}

	const handleEdit = () => {
		setOpen(false);
		selectedGeofence.groups = newGroups;
		updateGroup(selectedGeofence);
	}

	if (groups === null) return <CircularProgress />

	return (
		<div>
			<Tooltip title="Assign geofence to Group(s)">
				<div style={{ paddingLeft: '22px', paddingTop: '5px' }}>
					<Button
						color="default"
						variant="contained"
						aria-label="update"
						size='large'
						onClick={handleClickOpen}
					>
						Group Assignment
					</Button>
				</div>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Assign this geofence to Group(s)
				</DialogTitle>
				<DialogContent>
					<Autocomplete
						multiple
						id="tags-standard"
						options={groups.map((g) => g._id)}
						getOptionLabel={(option) => {
							return groups.filter((g) => {
								return g._id === option;
							})[0].name
						}}
						// defaultValue={vehicle.groups}
						size={'medium'}
						value={newGroups}
						filterSelectedOptions
						onChange={handleChange}
						renderInput={(params) => (
							<TextField
								{...params}
								variant="standard"
								label="Select Groups"
							// placeholder=""
							/>
						)}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleEdit} color="primary">
						Assign
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}

export default AssignGroupDialog
